import { z } from 'zod';

/** Mirrors the server rule (mailbox-service address.ts). */
export const LOCAL_PART_RE = /^[a-z0-9](?:[a-z0-9._+-]{0,62}[a-z0-9])?$/i;

export const createMailboxSchema = z.object({
  localPart: z.string().trim().min(1, 'Enter the part before the @')
    .max(64, 'At most 64 characters')
    .regex(LOCAL_PART_RE, 'Use letters, numbers, dots, hyphens, underscores or plus signs, starting and ending with a letter or number')
    .refine((v) => !v.includes('..'), 'Dots cannot be next to each other'),
  domainId: z.string().min(1, 'Choose a domain'),
  displayName: z.string().min(1, 'Name is required').max(120),
  password: z.string().min(12, 'At least 12 characters'),
  quotaGb: z.coerce.number().min(0).max(1024).default(5),
});
export type CreateMailboxValues = z.infer<typeof createMailboxSchema>;

export const editMailboxSchema = z.object({
  displayName: z.string().min(1, 'Name is required').max(120),
  status: z.enum(['active', 'suspended']),
  quotaGb: z.coerce.number().min(0).max(1024),
});
export type EditMailboxValues = z.infer<typeof editMailboxSchema>;

export const resetMailboxPwSchema = z.object({
  newPassword: z.string().min(12, 'At least 12 characters'),
  revokeSessions: z.boolean().default(true),
});
export type ResetMailboxPwValues = z.infer<typeof resetMailboxPwSchema>;

export const GB = 1024 * 1024 * 1024;
